import React from 'react';
import Layout from '../../sale/components/Layout';
import List from '../containers/List';

const Barbers = () => (
  <Layout>
    <div className="o-flexbox o-flexbox--column u-flex-1">
      <div className="u-mb">
        Select a barber
      </div>
      <div className="u-flex-1 u-mb">
        <List />
      </div>
    </div>
  </Layout>
);

export default Barbers;
